import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year1/Spring/MassAndVolume/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'MassAndVolume',
  field: 'Measurement',
  weeks: [11, 12],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/MassAndVolume/1HeavierAndLighter" */ './1HeavierAndLighter'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(/* webpackChunkName: "Year1/Spring/MassAndVolume/2MeasureMass" */ './2MeasureMass')
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(/* webpackChunkName: "Year1/Spring/MassAndVolume/3CompareMass" */ './3CompareMass')
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(/* webpackChunkName: "Year1/Spring/MassAndVolume/4FullAndEmpty" */ './4FullAndEmpty')
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/MassAndVolume/5CompareVolume" */ './5CompareVolume'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/MassAndVolume/6MeasureCapacity" */ './6MeasureCapacity'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/MassAndVolume/7CompareCapacity" */ './7CompareCapacity'
        )
    })
  ]
});
export default Block;
